export const HOUR_IN_MINUTES = 60;
export const DAY_IN_HOURS = 24;
export const HALF_AMPM_DAY = 12;
export const HALF_AN_HOUR_IN_MINUTES = HOUR_IN_MINUTES / 2;
export const AM = 'am';
export const PM = 'pm';
